import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import ComplianceView from "./compliance.view";

const useComplianceRoutes = () => (
  <Route path={pages.compliance.path} element={<ComplianceView />}>
    <Route index element={<ComplianceView />} />
  </Route>
);

export default useComplianceRoutes;
